// @ts-nocheck
import { Trans } from '@lingui/react'
import { arrayOf, bool, InferProps, shape, string } from 'prop-types'
import { type FC } from 'react'

import { DOCUMENT_TYPE } from 'shared/consts/checkout'
import NotificationOverdraftGroup from 'views/components/organisms/Cart/NotificationOverdraftGroup'
import ProductListing from 'views/components/organisms/Cart/ProductListing'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'

const singletonProductIdGroupName = 'maxdosage.groups.singletonProduct'

const ProductTypeListingProps = {
  productList: arrayOf(shape({})).isRequired,
  headline: string.isRequired,
  viewData: shape({}).isRequired,
  isERx: bool,
  overdrafts: arrayOf(shape({})),
  sellerId: string,
  isCollectiveOrderStatus: bool,
}

const ProductTypeListing: FC<InferProps<typeof ProductTypeListingProps>> = ({
  headline,
  productList,
  viewData,
  isERx = false,
  overdrafts,
}) =>
  overdrafts.map(group => {
    const groupedProducts =
      group.name === singletonProductIdGroupName
        ? productList.flatMap(product =>
            product.items.filter(
              item =>
                (item.matchedOverdrafts[0].name === group.name &&
                  item.pzn === group.singletonProductId) ||
                item.upid === group.singletonProductId
            )
          )
        : productList.flatMap(product =>
            product.items.filter(
              item => item.matchedOverdrafts[0].name === group.name
            )
          )

    return (
      <>
        <div data-qa-id="cart-overdraft-notification-productListing">
          <NotificationOverdraftGroup overdraft={group} />
        </div>
        <ProductListing
          productType={headline} // fixed headline because overdrafts cannot be isERX
          isERx={isERx}
          sellerId={group.name}
          products={groupedProducts}
          hasOverdraft
          hasOverdraftMaxed={
            group.orderedDosage && group.orderedDosage >= group.maxDosage
          }
          disabledSelect={
            group.orderedDosage && group.orderedDosage >= group.maxDosage
          }
          {...viewData}
        />
      </>
    )
  })

const ProductListOverdraftsProps = {
  sellerGroups: arrayOf(shape({})).isRequired,
  overdrafts: arrayOf(shape({})).isRequired,
  publicRuntimeConfig: shape({}),
}

const ProductListOverdrafts: FC<
  InferProps<typeof ProductListOverdraftsProps>
> = ({ sellerGroups = [], overdrafts = [] }) => {
  const overdraftItems = sellerGroups.reduce((filtered, seller) => {
    const items = seller.groupEntries
      .find(prescription => prescription.type === DOCUMENT_TYPE.NO_PRESCRIPTION)
      ?.items?.filter(
        item => item.matchedOverdrafts && item.matchedOverdrafts.length > 0
      )

    if (items.length > 0) {
      filtered.unshift({
        items,
        seller: seller.seller,
        sellerId: seller.sellerId,
      })
    }

    return filtered
  }, [])

  const sortedTypes = [
    overdraftItems.find(
      prescription => prescription.type === DOCUMENT_TYPE.INSURANCE_PRESCRIPTION
    ),
    overdraftItems.find(
      prescription => prescription.type === DOCUMENT_TYPE.FREE_PRESCRIPTION
    ),
    overdraftItems.find(
      prescription => prescription.type === DOCUMENT_TYPE.PRIVATE_PRESCRIPTION
    ),
  ].filter(Boolean)

  if (overdraftItems) {
    sortedTypes.unshift({
      type: DOCUMENT_TYPE.NO_PRESCRIPTION,
      itemsWithOverdrafts: overdraftItems,
    })
  }

  const offerViewDataConfig = {
    cta: false,
    noRemovalCTA: true,
    disabledSelect: false,
    renderBadge: false,
    showRedPoints: true,
    hideRedPoints: true,
    isFreebie: false,
    showAdditionalInformation: false,
  }

  return (
    <div>
      <h5
        className="o-ProductListCart__title"
        data-qa-id={`cart-entry-entryType-productsWithOverdrafts`}
      >
        <Trans
          id={'prescription.options.noPrescription.productsWithOverdrafts'}
        />
      </h5>

      <hr className="o-ProductListCart__divider" />

      {sortedTypes.map(sortedType => (
        <ProductTypeListing
          key={`${'seller'}-${sortedType.type}-overdrafts`}
          headline={sortedType.type}
          productList={sortedType.itemsWithOverdrafts}
          viewData={offerViewDataConfig}
          overdrafts={overdrafts}
          isOverdraft
        />
      ))}
    </div>
  )
}

export default withShopAndRuntimeConfig(ProductListOverdrafts)
